import React, { FC } from "react";
import InfoCard from "../../Cards/InfoCard";

interface ReasonSectionProps {}

const dummyData = [
  {
    icon: "earn.svg",
    title: "Simplified trading using wallets",
    description:
      "Our software simplifies futures trading to make it easy to earn in an uptrend or downtrend. Just send money to your up or down wallet to earn in either direction.",
  },
  {
    icon: "leverage.svg",
    title: "Get Leverage",
    description:
      "Get exposure to higher yields through Leverage. Leverage enables you gain multiples on your profits & losses as the price moves.",
  },
  {
    icon: "portfolio.svg",
    title: "Hedge your portfolio",
    description:
      "Now that you can take advantage of both price directions with GetFuture, you can hold portions of your investment in either wallets to insulate you against unexpected price movements.",
  },
];

const ReasonSection: FC<ReasonSectionProps> = () => {
  return (
    <div className="mx-8 xl:mx-20 2xl:mx-48 py-16 ">
      <div className="mb-16">
        <div className="text-center">
          <p className="text-2xl lg:text-3xl custom-text-green mb-16">Why use GetFuture?</p>
        </div>
        <div className="grid lg:grid-cols-3">
          {dummyData.map((data, index) => {
            const { title, description, icon } = data;
            return (
              <InfoCard
                key={index}
                title={title}
                description={description}
                icon={icon}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ReasonSection;
